/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import Header from "../asset/img/PenggerakOkOce.png";
import FloatingMenu from "../components/FloatingMenu";

const Penggerak = () => {
  const [movers, setMovers] = useState([]);

  useEffect(() => {
    fetchMovers();
  }, []);

  const fetchMovers = async () => {
    try {
      const response = await fetch("https://cms.okoce.net/api/admin/movers");
      if (!response.ok) {
        throw new Error("Gagal mengambil data penggerak");
      }
      const data = await response.json();
      setMovers(data.data || []);
    } catch (error) {
      setMovers([]);
    }
  };

  return (
    <>
      <div className="w-full mt-24">
        <img className="w-full h-auto" alt="" src={Header}></img>
      </div>

{/* <!-- component --> */}
<div className="mt-8 mb-4 flex items-center justify-center">
  <div className="container max-w-7xl mx-auto px-2">
    <div className="grid mobile:grid-cols-1 mobile:gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 lg:gap-2">
      {movers.map((mover, index) => (
        <div key={mover.id} className="flex flex-col items-center mb-4">
          <div className="relative w-40 h-40 mx-auto mb-2 rounded-xl overflow-hidden group p-4">
            <img
              className="w-full h-full object-contain"
              src={`${process.env.REACT_APP_API_URL}/${mover.image}`}
              alt={mover.name}
            />
       
          </div>
          <div className="text-center">
            <div className="font-bold text-lg mb-1">{mover.name}</div>
            <div
              className="text-gray-700 text-sm"
              dangerouslySetInnerHTML={{ __html: mover.description }}
            />
          </div>
        </div>
      ))}
    </div>
  </div>
</div>


      <div className="bg-[#1c75ac] max-w-6xl mx-auto rounded-xl p-10 text-white grid content-center mobile:h-full mobile:mt-20 mobile:p-8 lg:mt-8 lg:justify-center lg:h-auto mb-6 shadow-lg">
        <h1 className="font-extrabold text-3xl lg:text-4xl text-center leading-tight">
          Penggerak OK OCE Indonesia
        </h1>
        <p className="text-center mt-4 lg:mt-6 font-medium text-lg lg:text-xl max-w-2xl mx-auto">
          Penggerak OK OCE sebagai layer kedua dalam bangunan gerakan sosial
          penciptaan lapangan kerja berbasis wirausaha tersebar di berbagai
          daerah di seluruh Indonesia.
        </p>
        <p className="text-center mt-2 lg:mt-4 font-medium text-lg max-w-lg mx-auto">
          Anda dapat bergabung dengan penggerak-penggerak OK OCE di lokasi
          terdekat tempat tinggal Anda.
        </p>
        <a href="https://ecsys.okoce.net/" className="mx-auto mt-8 lg:mt-10">
          <button
            type="button"
            className="transition-all duration-300 transform hover:scale-105 hover:bg-blue-700 hover:text-white focus:ring-4 focus:ring-blue-500 font-medium rounded-full bg-white text-[#1c75ac] px-8 py-3 shadow-lg"
          >
            Gabung Jadi Penggerak &#10132;
          </button>
        </a>
      </div>

      <FloatingMenu />
    </>
  );
};

export default Penggerak;
